import React from 'react';

const WithBaseModal = (WrappedComponent) => (props) => {
  if (!props.open) {
    return <></>;
  }

  return <WrappedComponent {...props} />;
};
export default WithBaseModal;
